/* eslint-disable no-restricted-imports */
import type { IconBlobType } from '@glovo/uds-react'
import { IconBlob } from '@glovo/uds-react'
import classNames from 'classnames'
import type { FC } from 'react'
import styles from './IconBlobExtended.module.scss'
import type { IconBlobExtendedProps } from './types'
import { IconBlobTypeExtended } from './types'

export const IconBlobExtended: FC<IconBlobExtendedProps> = ({
  className,
  type = IconBlobTypeExtended.marketing,
  ...props
}) => {
  const overridenIconBlobProps = {
    ...props,
    type: type as IconBlobType,
  }

  return (
    <IconBlob
      className={classNames(className, styles['pintxo-icon-blob-extended'])}
      {...overridenIconBlobProps}
    />
  )
}
